import React, { memo, useContext, useEffect, useState } from 'react';
import { SiteConfig } from '@olxeu-a2b/delivery-utils/typings/config';
import Loader from '@olxeu-a2b/ui/src/commons/components/Loader';
import TransactionContext from '../contexts/TransactionContext';
import S from './style/ActionAcceptance';

interface Props {
  desktop?: boolean;
  baseDomains?: {
    desktop: SiteConfig;
    mweb: SiteConfig;
    delivery: SiteConfig;
  };
  onClose: () => void;
}

// IframeMessageType should be in sync with the messages sent from the unified seller rejection iframe (https://git.naspersclassifieds.com/pay-and-ship/unified-platform/-/blob/master/frontend/federation/seller_rejection/src/hooks/useIframeModal.ts?ref_type=heads#L5)
type IframeMessageType =
  | { type: 'closeModal' }
  | { type: 'resize'; height: number }
  | { type: 'loading'; isLoading: boolean };

const UnifiedSellerRejectionModal: React.FC<Props> = ({ desktop, baseDomains, onClose }) => {
  const transaction = useContext(TransactionContext);
  const [iframeHeight, setIframeHeight] = useState<number | undefined>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<IframeMessageType>) => {
      if (window?.location && event.origin !== window.location.origin) return;

      switch (event.data.type) {
      case 'closeModal':
        onClose();
        break;
      case 'resize':
        setIframeHeight(event.data.height);
        break;
      case 'loading':
        setLoading(event.data.isLoading);
        break;
      default:
        break;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <S.SellerRejectionModal position="center" maxWidth="504px" onClose={onClose}>
      {loading && <Loader />}

      <S.Iframe
        src={`/delivery/seller-rejection/${transaction?.id}/#iframe`}
        height={iframeHeight}
        isLoading={loading}
      />
    </S.SellerRejectionModal>
  );
};

export default memo(UnifiedSellerRejectionModal);
